export enum CarouselPeekWidth {
  LARGE = 40,
  MEDIUM = 30,
  SMALL = 20,
}
